import { render, staticRenderFns } from "./GroupLessons.vue?vue&type=template&id=8598d654&scoped=true&"
import script from "./GroupLessons.vue?vue&type=script&lang=js&"
export * from "./GroupLessons.vue?vue&type=script&lang=js&"
import style0 from "./GroupLessons.vue?vue&type=style&index=0&id=8598d654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8598d654",
  null
  
)

export default component.exports